import * as React from "react";
import Svg, { G, Rect, Path, Circle } from "react-native-svg";

function IcSystemEyeHide(props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      viewBox="0 0 24 24"
      {...props}
    >
      <G fill="none" fillRule="evenodd">
        <Rect width={24} height={24} />
        <Path
          stroke={props.accentColor}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M2,12 C4.66666667,7.33333333 8,5 12,5 C16,5 19.3333333,7.33333333 22,12 C19.3333333,16.6666667 16,19 12,19 C8,19 4.66666667,16.6666667 2,12 Z"
        />
        <Circle
          cx={12}
          cy={12}
          r={3}
          stroke={props.fillColor}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
        />
        <Path
          stroke="#FFF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M3.5,21.5 L21.5,3.5 C21.7761424,3.22385763 21.7761424,2.77614237 21.5,2.5 L21.5,2.5 C21.2238576,2.22385763 20.7761424,2.22385763 20.5,2.5 L2.5,20.5 C2.22385763,20.7761424 2.22385763,21.2238576 2.5,21.5 L2.5,21.5 C2.77614237,21.7761424 3.22385763,21.7761424 3.5,21.5 Z"
        />
        <Path
          stroke={props.accentColor}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M3,21 L21,3"
        />
      </G>
    </Svg>
  );
}

IcSystemEyeHide.defaultProps = {
  accentColor: "#687176",
  fillColor: "#0194F3",
  width: 24,
  height: 24,
};
export default IcSystemEyeHide;
